<template>
  <div
    class="Home"
    style="
background-image: url('imgs/bg_tj3tnc.jpg');
 background-size: cover;width: 100%;
    height: 100%;
"
  >
    <v-container fill-height fluid>
      <v-row>
        <v-spacer></v-spacer>
        <v-col>
          <v-card class="pa-2" elevation="24" outlined tile>
            <v-row>
              <!-- Linha do Logo + intranet -->
              <v-col>
                <v-img class="mt-5" height="80px" :contain="true" src="imgs/logo_vozhc2.png"></v-img>
                <v-card-title
                  class="justify-center text-uppercase grey--text text--darken-3"
                >Intranet</v-card-title>
                <v-card-subtitle align="center">
                  Este painel foi exclusivamente elaborado para uso dos
                  colaboradores do Escritório Líder de Contabilidade.
                </v-card-subtitle>
              </v-col>
              <v-col v-if="message">
                <v-alert class="mx-10" type="error" dense outlined>
                  {{
                  message
                  }}
                </v-alert>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <!-- Linha do formulario -->
                <v-form class="mx-10" v-model="valid" @submit.prevent>
                  <v-text-field
                    outlined
                    autocomplete="on"
                    label="E-mail"
                    :rules="emailRules"
                    v-model="user.email"
                    hint="Exemplo: victor.b"
                    suffix="@contabilidadelider.com"
                    prepend-icon="mdi-email"
                    required
                    clearable
                  ></v-text-field>
                  <v-text-field
                    outlined
                    autocomplete="on"
                    label="Senha"
                    prepend-icon="mdi-lock"
                    v-model="user.senha"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show1 ? 'text' : 'password'"
                    counter="15"
                    required
                    :rules="passRules"
                    @click:append="show1 = !show1"
                  ></v-text-field>
                  <v-row justify="center">
                    <v-col cols="3">
                      <v-btn
                        :loading="loading"
                        color="success"
                        :disabled="!valid"
                        x-large
                        type="submit"
                        @click="(loader = 'loading'), signin()"
                      >Entrar</v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-col>
            </v-row>
            <v-card-subtitle align="center">
              Av. Don Pedro II, 207 - Assis Chateaubriand - PR (44)3528-4363 -
              suporte@contabilidadelider.com
            </v-card-subtitle>
          </v-card>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import User from "../models/user";
export default {
  data() {
    return {
      show1: false,
      loading: false,
      loader: null,
      valid: true,
      message: "",
      user: new User("", ""),
      emailRules: [
        (v) => !!v || "Informe o e-mail",
        (v) => v.length <= 15 || "Seu usuário deve ter no máximo 15 caracteres",
      ],
      passRules: [
        (v) => !!v || "Informe sua senha",
        (v) => v.length <= 15 || "Sua senha deve ter no máximo 15 caracteres",
      ],
    };
  },
  methods: {
    signin() {
      this.$store.dispatch("login", this.user).then(
        () => {
          this.$router.push("/Dash").catch(() => {});
        },
        (error) => {
          this.loading = error;
          this.loading = false;
          this.message = "Email ou Senha informada estão incorretos.";
        }
      );
    },
  },

  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 500);

      this.loader = null;
    },
  },
  mounted() {
    this.$store.dispatch("infoUsuario").then(
      () => {
        this.$router.push("/Dash");
      },
      () => {}
    );
  },
};
</script>
